import { createAction, props } from '@ngrx/store';

export const loadPlanners = createAction('[Planner Lookup] Load');

export const loadPlannersSuccess = createAction(
  '[Planner Lookup] Load Success',
  props<{ planners: Array<{ id: number; name: string }> }>()
);

export const loadPlannersFailure = createAction(
  '[Planner Lookup] Load Failure',
  props<{ error: string }>()
);
